import React from "react";
import Modal, { ModalTransition } from "@atlaskit/modal-dialog";
import apiClient from "../../api/api-client";
import { toast } from "react-toastify";
import useAsync from "../../hooks/use-async";
import { useTranslation } from "react-i18next";

export default function RemoveUserFromDocument({ documentId, user, onRemoved, onClose }) {
    const { t } = useTranslation();
    const { run, isPending } = useAsync();
    const remove = () => {
        run(apiClient(`document/${documentId}/share`, { method: "DELETE", data: {
            user_id: user?.user_id
        }}))
            .then(() => {
                toast.success(t("document_users_remove_success"));
                onRemoved && onRemoved();
            })
            .catch(error => toast.error(t("document_users_remove_fail") +  error.message));
    };

    return (
        <>
            <ModalTransition>
                <Modal
                    isLoading={isPending}
                    actions={[
                        { text: t("document_users_confirm_button_remove"), onClick: remove, isLoading: isPending },
                        { text: t("document_users_confirm_button_cancel"), onClick: onClose, isDisabled: isPending },
                    ]}
                    onClose={close}
                    heading={t("document_users_confirm_heading")}
                    appearance="danger"
                >
                    <p>
                        {t("document_users_confirm_p")}
                    </p>
                </Modal>
            </ModalTransition>
        </>
    );
}